// 路由中间件
import { isGlobal } from '~/plugins/global.js'
import { mergeUrlList, noRiskUrlList } from '~/assets/js/domain.js'
import { getIP, getLanguage, getMyCountry } from '~/assets/js/utils.js'
const divide = require('lodash/divide')

export default async ({ isHMR, app, $api, $cookies, route, store, req, redirect }) => {
  // 热更新状态下，不执行后续操作
  if (isHMR || route?.path?.includes('HealthCheck/Get')) return false

  // 判断当前设备是否为移动端
  const userAgent = req ? req.headers['user-agent'] : navigator.userAgent || ''
  const isMobile = userAgent?.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) || false

  // 处理语言
  const { langList, countryCode, cookieVal } = store.state
  let { locale: lang = '' } = store.state
  lang = getLanguage(isGlobal, route?.params, $cookies, req?.headers['accept-language'], langList)
  app.i18n.locale = lang
  const myAddress = getIP(req) // IP地址
  const myHost = req?.headers?.host?.replace('aws-', '')?.replace('aws.', '') // 域名
  console.log('myHost::: ', myHost)
  store.commit('setVal', { isMobile, ip: myAddress, isChina: !isGlobal, fullHost: myHost, locale: lang })
  const suffix = myHost?.split('.')?.[2] || 'com'
  console.log('suffix::: ', suffix)
  store.commit('setsuffix', suffix)
  $cookies.set('LanguageCode', lang, store.getters.cookConf)

  // VPS账户详情路由处理
  if (route?.path?.includes('/jzzs') || route?.path?.includes('/dqcc')) return redirect(`/${lang}/zhsy?MTAccount=${route?.query?.MTAccount}`)
  if ((suffix === 'hk') && (!myHost.includes('/zh-cn') || app.$cookies.get('CountryCode') != 'cn')) {
    store.commit('setCountryCode', 'cn')
    $cookies.set('CountryCode', 'cn', store.getters.cookConf)
    app.i18n.locale = 'zh-cn'
    if (!myHost.includes('/zh-cn')) return redirect(302, `/zh-cn/${route.fullPath.split('/').slice(2).join('/')}`)
  }

  // 处理国家code码、用户所在的国家
  let ipCountry = 'us'
  try {
    const { country_code: cc = '' } = await $api.home.myIPApi({ ip: myAddress }).catch(() => {})
    ipCountry = (cc || '')?.toLowerCase() // 获取用户所在的国家
  } catch (error) {}
  const myCountry = (isGlobal ? ipCountry : 'cn')
  store.commit('setVal', { myCountry })
  let nationCode = myCountry
  if (!countryCode) {
    store.commit('setCountryCode', isGlobal ? getMyCountry({ twoCharCode: ipCountry?.toUpperCase() })?.countryCode || '840' : '156') // 换取国家code码
    $cookies.set('CountryCode', myCountry, store.getters.cookConf)
  } else {
    nationCode = getMyCountry({ countryCode })?.twoCharCode?.toLowerCase() || 'us'
  }

  // 若浏览器地址栏的语言不存在于语言列表中，更换语言，并跳转至对应页面
  const currLang = (route.params.lang || '')?.toLowerCase() // 获取浏览器地址栏参数
  const isMyLang = currLang && langList.includes(currLang) // 浏览器地址栏的语言是否存在于语言列表中
  if (currLang && !isMyLang) return redirect(route?.path?.replace(`/${route.params.lang}`, `/${lang}`))

  try {
    await $api.home.riskcontrol().then((riskcontrol) => {
      store.commit('setRiskObjData', riskcontrol)
      // console.log('riskcontrol::: ', riskcontrol && riskcontrol['351001'] == 0)
      if (riskcontrol && riskcontrol['351001'] == 0) {
        if (currLang == 'zh-cn' || currLang == 'zh') {
          console.log('去中文')
          return redirect(route?.path?.replace(`/${route.params.lang}`, '/en'))
        }
      }
    }).catch((err) => {
      console.log('$api.home.riskcontrol--err' + err)
    })
  } catch (error) {
    console.log('这里错222')
    console.log('error::: ', error)
  }

  // 获取公用底部数据、用户cookie信息
  try {
    const apiArr = []
    if (cookieVal) apiArr.push($api.login.getUserCookie({ contentcookie: cookieVal }))
    const [contactObj, bottomCountry, aggregation, uObj] = await Promise.all([
      $api.home.contactInfo(),
      $api.home.countryHot(),
      $api.common.v3Server({ Routes: 'search$getcountryinfo', BasicData: store.getters?.getDiffBasic }, { codes: [ipCountry, nationCode], languageCode: lang }),
      ...apiArr
    ])

    const nationArr = aggregation?.search?.getcountryinfo?.data || []

    // bottomCountry?.forEach((item) => {
    //   if (['158', '344'].includes(item.code)) item.name = item.name?.replace('中国', '')?.replace('中國', '')?.replace('China', '')
    // })
    store.commit('setVal', {
      contact: contactObj || '',
      countryList: bottomCountry || [],
      simpleUser: uObj?.result || {},
      ipNation: nationArr?.[0] || {},
      selectNation: nationArr?.[1] || {}
    })
  } catch (error) {
    console.log('这里错?')
  }

  if (store?.state?.simpleUser?.result?.userId) {
    await $api.common.v3Server(
      { Routes: 'westaffmanage$staffsimpleinfo' },
      { userId: store.state.simpleUser?.result?.userId }
    ).then((res) => {
      const code = res?.westaffmanage?.staffsimpleinfo?.data?.enterpriseCode || ''
      if (code) {
        this.setCookie('EnterpriseCode', code)
      }
    })
  }

  // 国内版，可能需要隐藏个别头部菜单项
  if (!isGlobal) {
    try {
      const menuArr = await Promise.all([
        $api.home.showMenu({ projectType: 0, point: 25, platform: 10, ip: myAddress, unix: divide(Date.parse(new Date()), 1000) }),
        $api.home.showMenu({ projectType: 0, point: 50, platform: 10, ip: myAddress, unix: divide(Date.parse(new Date()), 1000) })
      ])
      store.commit('setMenu', {
        ea: menuArr[0]?.result?.value == 'true',
        vps: menuArr[1]?.result?.value == 'true'
      })
    } catch (error) {}
  }

  const bfp = $cookies.get('wiki-bfp') ? $cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
  let base = `999,0,2,999,0,${bfp},0`
  if (store.getters.isFxCom) {
    base = `999,0,2,999,0,${bfp},0`
  } else if (store.state.myCountry == 'cn') {
    base = `999,0,1,999,1,${bfp},1`
  } else {
    base = `999,0,2,999,0,${bfp},0`
  }

  store.commit('setVal', { showShield: await handleRedRisk() })

  // 处理红框逻辑
  async function handleRedRisk () {
    if ($cookies.get('jgpass_new') || myCountry != 'cn' || noRiskUrlList?.includes(myHost)) return false // 这些情景不展示红框：cookie中已有值；IP不在中国大陆；特殊域名
    // 以下代码处理：中国大陆访问网站时，判断是否需要展示红框
    if (isGlobal && !mergeUrlList?.includes(myHost)) return true // 例如.wikifx.com等域名需要展示红框
    const { result = [] } = await $api.home.getmanybyproj({ BasicData: base, 'x-forword-for': myAddress }).catch(() => {})
    const findedObj = result?.find(item => item.point == 175) || {} // 例如.wikifxzh.com等域名根据接口返回值来判断是否需要展示红框
    return findedObj?.value == 'true'
  }
}
